import { render, staticRenderFns } from "./TolTable.vue?vue&type=template&id=1f271ffc&scoped=true&"
import script from "./TolTable.vue?vue&type=script&lang=js&"
export * from "./TolTable.vue?vue&type=script&lang=js&"
import style0 from "./TolTable.vue?vue&type=style&index=0&id=1f271ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f271ffc",
  null
  
)

export default component.exports